import { Typography } from '@mui/material';
import type { ReactNode } from 'react';

interface KindTagProps {
  children: ReactNode;
  /** Theme palette path; defaults to the quiet caption colour. */
  color?: string;
}

/** Unboxed caption after a title ("Not booked"). Quiet by design. */
export const KindTag = ({
  children,
  color = 'text.secondary',
}: KindTagProps) => (
  <Typography
    component="span"
    variant="caption"
    noWrap
    sx={{ color, flexShrink: 0 }}
  >
    {children}
  </Typography>
);
